import styled from "@emotion/styled";
import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type {
  ContentSchemaRenderProps,
  RenderComponent,
} from "~/components/content/content-schema-render";
import type { blockquoteQuoteContent$key } from "~/queries/__generated__/blockquoteQuoteContent.graphql";

import QuoteIcon from "./icon-quote.svg";
import {
  StyledBlockquote,
  StyledContentShareWidget,
  StyledFigcaption,
  StyledFigure,
  StyledFooter,
} from "./styles";

type Props = {
  reference: blockquoteQuoteContent$key;
} & ContentSchemaRenderProps;

const Component: FunctionComponent<Props> = ({ reference: reference_, schemaNode }) => {
  const content = useFragment(
    graphql`
      fragment blockquoteQuoteContent on Content {
        ...contentShareWidgetContent
      }
    `,
    reference_,
  );

  const [quoteNode, sourceNode] = schemaNode.children ?? [];

  return (
    <StyledFigure>
      <QuoteIcon />
      <StyledBlockquote>{quoteNode?.data}</StyledBlockquote>
      <StyledFigcaption>{sourceNode?.data}</StyledFigcaption>
      <StyledFooter>
        <StyledContentShareWidget
          reference={content}
          style={{ backgroundColor: "transparent", color: "#001246" }}
          types={["facebook", "twitter", "email"]}
        />
      </StyledFooter>
    </StyledFigure>
  );
};

Component.displayName = "BlockquoteQuote";

export const BlockquoteQuote: RenderComponent = styled(Component)``;
BlockquoteQuote.isHandlingOwnChildren = true;
